import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-calendar/es/index.js
// module id = 255
// module chunks = 0 1